module.exports = __webpack_public_path__ + "img/none.a0692bdf.png";